/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ServiceAccountCreatedSchema } from '../models/ServiceAccountCreatedSchema';
import type { ServiceAccountCreateSchema } from '../models/ServiceAccountCreateSchema';
import type { ServiceAccountDetailSchema } from '../models/ServiceAccountDetailSchema';
import type { ServiceAccountListSchema } from '../models/ServiceAccountListSchema';
import type { ServiceAccountPatchSchema } from '../models/ServiceAccountPatchSchema';
import type { ServiceAccountTokenCreatedSchema } from '../models/ServiceAccountTokenCreatedSchema';
import type { ServiceAccountTokenCreateSchema } from '../models/ServiceAccountTokenCreateSchema';
import type { ServiceAccountTokenReadSchema } from '../models/ServiceAccountTokenReadSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ServiceAccountsApi {
    /**
     * List Service Accounts
     * Get list of service accounts of my company.<br>Required Permission: list_service_accounts
     * @returns ServiceAccountListSchema OK
     * @throws ApiError
     */
    public static serviceAccountsListServiceAccountsGet(): CancelablePromise<Array<ServiceAccountListSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/service-accounts/',
        });
    }
    /**
     * Create Service Account
     * Create a service account together with its first API token. The plaintext token is returned exactly once and cannot be retrieved again - only its hash is stored.<br>Required Permission: create_service_account
     * @returns ServiceAccountCreatedSchema Created
     * @throws ApiError
     */
    public static serviceAccountsCreateServiceAccountPost({
        requestBody,
    }: {
        requestBody: ServiceAccountCreateSchema,
    }): CancelablePromise<ServiceAccountCreatedSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/service-accounts/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Service Account
     * Get service account detail.<br>Required Permission: get_service_account_detail
     * @returns ServiceAccountDetailSchema OK
     * @throws ApiError
     */
    public static serviceAccountsGetServiceAccountGet({
        serviceAccountId,
    }: {
        serviceAccountId: string,
    }): CancelablePromise<ServiceAccountDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/service-accounts/{service_account_id}/',
            path: {
                'service_account_id': serviceAccountId,
            },
        });
    }
    /**
     * Update Service Account
     * Update a service account. Passing 'scopes' replaces the whole set of granted permissions.<br>Required Permission: update_service_account
     * @returns ServiceAccountDetailSchema OK
     * @throws ApiError
     */
    public static serviceAccountsUpdateServiceAccountPatch({
        serviceAccountId,
        requestBody,
    }: {
        serviceAccountId: string,
        requestBody: ServiceAccountPatchSchema,
    }): CancelablePromise<ServiceAccountDetailSchema> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/service-accounts/{service_account_id}/',
            path: {
                'service_account_id': serviceAccountId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Service Account
     * Delete a service account, its tokens and its machine user.<br>Required Permission: delete_service_account
     * @returns void
     * @throws ApiError
     */
    public static serviceAccountsDeleteServiceAccountDelete({
        serviceAccountId,
    }: {
        serviceAccountId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/service-accounts/{service_account_id}/',
            path: {
                'service_account_id': serviceAccountId,
            },
        });
    }
    /**
     * List Service Account Tokens
     * List tokens of a service account. Secrets are never returned.<br>Required Permission: list_service_account_tokens
     * @returns ServiceAccountTokenReadSchema OK
     * @throws ApiError
     */
    public static serviceAccountsListServiceAccountTokensGet({
        serviceAccountId,
    }: {
        serviceAccountId: string,
    }): CancelablePromise<Array<ServiceAccountTokenReadSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/service-accounts/{service_account_id}/tokens/',
            path: {
                'service_account_id': serviceAccountId,
            },
        });
    }
    /**
     * Create Service Account Token
     * Issue an additional API token. Use this to rotate credentials: issue a new token, deploy it, then revoke the old one. The plaintext token is returned exactly once.<br>Required Permission: create_service_account_token
     * @returns ServiceAccountTokenCreatedSchema Created
     * @throws ApiError
     */
    public static serviceAccountsCreateServiceAccountTokenPost({
        serviceAccountId,
        requestBody,
    }: {
        serviceAccountId: string,
        requestBody: ServiceAccountTokenCreateSchema,
    }): CancelablePromise<ServiceAccountTokenCreatedSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/service-accounts/{service_account_id}/tokens/',
            path: {
                'service_account_id': serviceAccountId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Revoke Service Account Token
     * Revoke a token. The row is kept so it stays auditable.<br>Required Permission: revoke_service_account_token
     * @returns ServiceAccountTokenReadSchema OK
     * @throws ApiError
     */
    public static serviceAccountsRevokeServiceAccountTokenPost({
        serviceAccountId,
        tokenId,
    }: {
        serviceAccountId: string,
        tokenId: string,
    }): CancelablePromise<ServiceAccountTokenReadSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/service-accounts/{service_account_id}/tokens/{token_id}/revoke/',
            path: {
                'service_account_id': serviceAccountId,
                'token_id': tokenId,
            },
        });
    }
}
